'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteComment = exports.updateComment = exports.getComments = exports.createComment = undefined;

var _createComment2 = require('./createComment');

var _createComment3 = _interopRequireDefault(_createComment2);

var _getComments2 = require('./getComments');

var _getComments3 = _interopRequireDefault(_getComments2);

var _updateComment2 = require('./updateComment');

var _updateComment3 = _interopRequireDefault(_updateComment2);

var _deleteComment2 = require('./deleteComment');

var _deleteComment3 = _interopRequireDefault(_deleteComment2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.createComment = _createComment3.default;
exports.getComments = _getComments3.default;
exports.updateComment = _updateComment3.default;
exports.deleteComment = _deleteComment3.default;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/comments/index.js
// module id = 226
// module chunks = 0